import { PaintedScene } from '../PaintedScene';

export const ASH_PASS_NIGHT_PHASER_KEY = 'AshPassNightScene' as const;
export const ASH_PASS_NIGHT_MANIFEST_KEY = 's-405-ash-pass-night' as const;

export class AshPassNightScene extends PaintedScene {
  constructor() {
    super(ASH_PASS_NIGHT_PHASER_KEY, ASH_PASS_NIGHT_MANIFEST_KEY);
  }
}
